import {
  Card,
  CardBody,
  Input,
  TableRow,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import SeoVirtualTable from "components/seoManageCity/SeoVirtualTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import SeoVirtualDrawer from "components/drawer/SeoVirtualDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import SeoVirtualServices from "services/SeoVirtualServices";
import sidebar from "routes/sidebar";
import { FiRefreshCcw } from "react-icons/fi";
import { Tabs, Tab } from "@mui/material";

const SeoVirtual = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer, setIsUpdate, isUpdate} = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const { loading, setLoading, error } = useAsync(() =>
    SeoVirtualServices.getAllSeoVirtual()
  );
  const [contactData, setContactData] = useState([]);
  const [filteredContact, setFilteredContact] = useState([]);
  const [tab, setTab] = useState(0);
  const [contactType, setContactType] = useState("1"); // 1 = CoWorking, 2 = virtual 

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = tab === 0
          ? await SeoVirtualServices.getAllSeoVirtual()
          : await SeoVirtualServices.getAllContact();

        setStatus(response.status);

        if (tab === 0) {
          setData(response.data);
          setOriginalData(response.data);
        } else {
          const all = response.data || [];
          // console.log("api call tab 1 data", all);
          setContactData(all);
          // Filter only coworking (1) or virtual (2)
          const filtered = all.filter(
            (item) => String(item.type) === String(contactType)
          );
          //  console.log("filtered data", filtered);

          setFilteredContact(filtered);
          //   setData(filtered);
        }
        // console.log("api call tab data", response);

      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
        setIsUpdate(false);
      }
    };

    fetchData();
  }, [tab, offset, contactType, isUpdate]);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { seoVirtualRef, serviceData } = useFilter(
    Array.isArray(data?.data) ? data?.data : [],
    itemsPerPage
  );
  const updatedData = data?.data?.map((item) => {
    const { id, ...rest } = item; // Use destructuring to remove id
    return rest; // Return the object without id
  });

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "seo virtual" && perm.view === 1
    );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "seo virtual" && perm.delete === 1
    );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "seo virtual" && perm.edit === 1
    );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "seo virtual" && perm.add === 1
    );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "seo virtual" && perm.export === 1
    );

  const handleSearch = () => {
    const searchTerms = seoVirtualRef.current.value
      ?.toLowerCase()
      .trim()
      .split(" ")
      .filter(Boolean);

    if (!searchTerms.length) {
      setData(originalData); // Reset to original data if search is empty
      return;
    }

    const filteredData = (tab === 0 ? originalData : filteredContact).filter((search) =>
      searchTerms.every((term) => {
        term = term.toLowerCase();

        return tab === 0
          ? (
            (search?.url || "").toLowerCase().includes(term) ||
            (search?.keywords || "").toLowerCase().includes(term) ||
            (search?.title || "").toLowerCase().includes(term)
          )
          : (
            ((search?.name ||
              `${search?.firstname || ""} ${search?.lastname || ""}`) || "")
              .toLowerCase()
              .includes(term) ||
            (search?.email || "").toLowerCase().includes(term) ||
            (search?.phone || "").toLowerCase().includes(term) ||
            (search?.company_name || "").toLowerCase().includes(term)
          );
      })
    );

    setData(filteredData);
  };

  const csvData = [
    ["SI.No", "URL", "Title", "Keywords", "Description", "Content"],
    ...originalData?.map(
      ({ url, title, keywords, description, content }, index) => [
        index + 1,
        url,
        title,
        keywords,
        description,
        content,
      ]
    ),
  ];

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const getTabName = () => {
    if (tab === 0) return "Seo virtual";
    if (tab === 1) return "Contact";
    return "";
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <MainDrawer>
            <SeoVirtualDrawer id={serviceId} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
                  <Input
                    ref={seoVirtualRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSearch}
                  />
                </div>
                {(tab === 0) && hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Seo
                  </Button>
                )}
                {hideExport && (
                  <div className="items-center">
                    <ExportDataXlsx
                      exportDataXlsx={csvData}
                      fileNames="Seo Virtual"
                    />
                  </div>
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>

          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{ style: { backgroundColor: "#057a55" } }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
                fontWeight: "medium",
                color: "gray",
                "&.Mui-selected": { color: "#057a55", fontWeight: "semibold" },
              },
              marginBottom: "16px",
            }}
          >
            <Tab label="Seo Virtual" />
            <Tab
              label={
                <div className="flex items-center gap-3">
                  Contact
                  {tab === 1 && (
                    <select
                      value={contactType}
                      onChange={(e) => setContactType(e.target.value)}
                      className="border px-2 py-1 rounded text-sm"
                      style={{ background: "white" }}
                    >
                      <option value="1">Coworking</option>
                      <option value="2">Virtual</option>
                    </select>
                  )}
                </div>
              }
            />
          </Tabs>

          <DataWrapper loading={loading} error={error} status={status}>
            {data?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize text-center sticky top-0 z-10 text-sm">
                      <TableRow>
                        {tab === 0 ? (
                          <>
                            <TableCell>SI.No.</TableCell>
                            <TableCell>URL</TableCell>
                            <TableCell>Keywords</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Actions</TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell>SI.No.</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Company Name</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Actions</TableCell>
                          </>
                        )}
                      </TableRow>
                    </TableHeader>
                    <SeoVirtualTable
                      seodata={tab === 0 ? data : filteredContact}
                      perpage={tab === 0 ? data.length : filteredContact.length}
                      currentPage={tab === 0 ? data.length : filteredContact.length}
                      hideEdit={hideEdit}
                      hideDelete={hideDelete}
                      hideView={hideView}
                      setOffset={setOffset}
                      tab={tab}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <NotFound title="There are no Pages." />
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default SeoVirtual;
